import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface ChatLockState {
  lockedChannels: Record<string, boolean>; // key = channelId
}

const initialState: ChatLockState = {
  lockedChannels: {},
}

export const chatLockSlice = createSlice({
  name: 'chatLock',
  initialState,
  reducers: {
    activate: (state, action: PayloadAction<string>) => {
      const channelId = action.payload;
      state.lockedChannels[channelId] = true;
    },
    deactivate: (state, action: PayloadAction<string>) => {
      const channelId = action.payload;
      state.lockedChannels[channelId] = false;
    },
    resetLocks: (state) => {
      state.lockedChannels = {};
    },
  },
})

// Action creators
export const { activate, deactivate, resetLocks } = chatLockSlice.actions;

export default chatLockSlice.reducer;
